import classNames from 'classnames';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

import dayjs from 'dayjs';
import InfiniteScroll from 'react-infinite-scroller';
import { logging, logPostInfo } from '../../actions/log';
import { getSpecialListList, getSpecialListTags, getSpecialLoading } from '../../actions/special';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import { CONTEXT } from '../../config';
import zt_blank from '../../static/zt_blank.png';
import { getQueryString } from '../../utils/utils';
import styles from './SpecialList.module.less';
import Select from '../../components/Select/Select';
import nodata from '../../static/special_nodata.png';

const sortList = [
  {
    text: '按时间',
    name: 1,
  },
  {
    text: '浏览量',
    name: 2,
  },
  {
    text: '点赞数',
    name: 3,
  },
];
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectTags = createSelector(
  state => state.special,
  special => special.specialTags,
);
const selectZtList = createSelector(
  state => state.special,
  special => special.specialList,
);
const selectPagenation = createSelector(
  state => state.special,
  special => special.pagenation,
);
export default memo(() => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [activePageType, setActivePageType] = useState(getQueryString('pageType') || null); // 分类
  const [activePageTag, setActivePageTag] = useState(getQueryString('pageTag') || null); // 标签
  const [tagList, setTagList] = useState([]); // 标签展示数据
  const [sortType, setSortType] = useState(
    (getQueryString('sort') && sortList[getQueryString('sort') - 1]) || sortList[0],
  );

  const [pageTypeParam, setPageTypeParam] = useState(null);

  const classify = useSelector(selectTags) || []; // 分类展示数据
  const ztlist = useSelector(selectZtList);
  const pagenation = useSelector(selectPagenation);
  const [loading, setLoading] = useState(false);

  const [node, setNode] = useState(null);
  const [hasInit, setHasInit] = useState(false);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Special_List`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  // 获取分类页面标签
  useEffect(() => {
    if (history.action !== 'POP' || !classify || classify.length === 0) {
      dispatch(getSpecialListTags());
    }
  }, []);

  /**
   * 梳理pageType 获取数据
   */
  useEffect(() => {
    if (history.action !== 'POP' || ztlist.length === 0) {
      const pageTypeUrl = getQueryString('pageType') || 'all';
      let pageType = pageTypeUrl;
      if (pageTypeUrl !== 'game') {
        pageType = 'all';
      }
      // 如果
      if (
        pageTypeUrl === 'special' ||
        pageTypeUrl === 'detail' ||
        pageTypeUrl === 'anDetail' ||
        pageTypeUrl === 'recommend'
      ) {
        const ztTypeUrl = getQueryString('ztType') || '';
        if (ztTypeUrl === '') {
          pageType = 'all';
        }
        pageType = ztTypeUrl;
      }
      setPageTypeParam(pageType);
      setActivePageType(pageType);
    }
  }, []);

  // 变更分类选择 重置标签展示数据
  useEffect(() => {
    if (activePageType) {
      const targetClassify = classify.find(item => item.code === activePageType) || {};
      setTagList(targetClassify.tags || []);
      if (hasInit || !activePageTag) {
        setActivePageTag(
          targetClassify.tags && targetClassify.tags[0] && targetClassify.tags[0].tagId,
        );
      }
    }
  }, [activePageType, classify]);
  // 变更分类标签 页面重新请求
  useEffect(() => {
    if (!hasInit && history.action === 'POP' && ztlist.length !== 0) {
      setHasInit(true);
      return;
    }
    if (activePageTag && activePageType) {
      dispatch(
        getSpecialListList({
          code: activePageType,
          tagId: activePageTag,
          sort: sortType.name,
          refresh: true,
          skip: 0,
          limit: 24,
        }),
      );
    }
    setHasInit(true);
  }, [activePageTag, activePageType, sortType]);

  // 页面初始化 返回定位
  useEffect(() => {
    if (history.action === 'POP' && ztlist.length !== 0 && node) {
      const el = document.querySelector('#container_content');
      const ss = getQueryString('scrollTop');
      el.scrollTo(0, ss);
    }
  }, [node]);
  // 数据请求发生错误 跳转其他页面
  useEffect(() => {
    if (pagenation.error) {
      dispatch(
        getSpecialLoading({
          pagenation: {
            ...pagenation,
            error: false,
          },
        }),
      );
      history.push(`${CONTEXT}/error`);
    }
  }, [pagenation]);
  // 监听页面首次loading状态
  useEffect(() => {
    setLoading(true);
  }, []);
  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [ztlist, loading]);
  useEffect(() => {
    // PV
    if (pageTypeParam) {
      dispatch(
        logging({
          category: 'P',
          action: 'Special_List',
          label: '',
          param2: {
            source: `Special_List`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pageType: pageTypeParam,
            tab: pageTypeParam,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        }),
      );
    }
  }, [dispatch, logInfoData, pageTypeParam]);

  const handleZtCard = zt => () => {
    // 点击tab
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ztId: zt.ztId,
          tab: activePageType,
          pageType: pageTypeParam,
        },
      }),
    );
    if (zt.ztId) {
      dispatch(
        logPostInfo({
          source_p: `Special_List`,
          source_pp: logInfoData.source_p,
        }),
      );
      const el = document.querySelector('#container_content');
      history.replace(
        `${CONTEXT}/speciallist?pageType=${activePageType}&pageTag=${activePageTag}&sort=${
          sortType.name
        }&scrollTop=${(el && el.scrollTop) || 0}`,
      );
      history.push(`${CONTEXT}/special?ztId=${zt.ztId}`);
    }
  };

  const handleNumber = (data = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+data)) {
      return data;
    }
    if (+data < 1000) {
      return data;
    }
    if (+data < 10000) {
      return `${(data / 1000).toFixed(1)}k`;
    }

    return `${(data / 10000).toFixed(1)}w`;
  };

  const handleClassify = code => () => {
    // 点击tab
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List_Tab',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          pageType: pageTypeParam,
          category: code,
          tab: activePageTag,
        },
      }),
    );
    setActivePageType(code);
  };

  const handleTag = code => () => {
    // 点击tab
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List_Tab',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          pageType: pageTypeParam,
          category: activePageType,
          tab: code,
        },
      }),
    );
    setActivePageTag(code);
  };

  const handleSort = value => {
    setSortType(value);
    // setActivePageType('all');
    dispatch(
      logging({
        category: 'C',
        action: 'Special_List_Sort',
        label: '',
        param2: {
          source: `Special_List`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          category: activePageType,
          tab: activePageTag,
          sort: value.name,
        },
      }),
    );
  };

  const loadMore = () => {
    if (pagenation.loading || pagenation.count <= ztlist.length) {
      return;
    }
    dispatch(
      getSpecialLoading({
        pagenation: {
          ...pagenation,
          loading: true,
        },
      }),
    );
    dispatch(
      getSpecialListList({
        code: activePageType,
        tagId: activePageTag,
        sort: sortType.name,
        refresh: false,
        skip: ztlist.length,
        limit: 24,
      }),
    );
  };
  const handleRef = useCallback(
    r => {
      setNode(r);
    },
    [node],
  );
  const handleMouseLeave = e => {
    if (e && e.currentTarget) {
      e.currentTarget.className = `${e.currentTarget.className} ${styles.image_mouse_out}`;
    }
  };
  if (loading) {
    return <Loading />;
  }
  return (
    <div>
      <div className={styles.specialList_header}>
        <div className={styles.specialList_header_text}>全部专题</div>
        <div className={styles.specialList_header_sort}>
          <Select options={sortList} defaultValue={sortType} handleChange={handleSort} />
        </div>
        <div className={styles.specialList_header_classify}>
          {classify && classify.length > 0 && (
            <div className={classNames(styles.start_grid)}>分类：</div>
          )}
          {classify.map((item, index) => {
            return (
              <div
                key={`${index}_${item.code}`}
                className={classNames(styles.common_grid, {
                  [styles.active]: item.code === activePageType,
                })}
                onClick={handleClassify(item.code)}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        <div className={styles.specialList_header_classify}>
          {tagList && tagList.length > 0 && <div className={styles.start_grid}>标签：</div>}
          {tagList.map((item, index) => {
            return (
              <div
                key={`${index}_${item.tagId}`}
                className={classNames(styles.common_grid, {
                  [styles.active]: item.tagId === activePageTag,
                })}
                onClick={handleTag(item.tagId)}
              >
                {item.tagName}
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.specialList_main} ref={handleRef}>
        {ztlist &&
          ztlist.length > 0 &&
          activePageType === pagenation.code &&
          activePageTag === pagenation.tagId && (
            <InfiniteScroll
              pageStart={1}
              loadMore={loadMore}
              hasMore={(ztlist && ztlist.length) < (pagenation && pagenation.count)}
              loader={
                <div className={classNames('loader', styles.loader)} key={0}>
                  ----------加载中----------
                </div>
              }
              initialLoad={false}
              useWindow={false}
              getScrollParent={() => document.getElementById('container_content')}
            >
              <div className={styles.content_column3}>
                {ztlist.map((item, index) => (
                  <div
                    className={classNames(
                      styles.zt_card,
                      {
                        [styles.zt_card_center]: index % 3 === 1,
                      },
                      styles.image_mouse_in,
                      // styles.image_mouse_out,
                    )}
                    onMouseLeave={handleMouseLeave}
                    onClick={handleZtCard(item)}
                    key={`${index}_${item.ztId}`}
                  >
                    <div className={styles.zt_card_img_box}>
                      <img src={item.ztImg || zt_blank} alt="" className={styles.zt_card_img} />
                    </div>
                    <div className={styles.zt_card_title}>{item.ztTitle}</div>
                    <div className={styles.zt_card_info}>
                      <div>{dayjs(item.pushTime).format('YYYY/MM/DD')}</div>
                      <div className={classNames(styles.zt_card_grid_icon)}>
                        <div className={classNames(styles.zt_card_icon)}>
                          <i className="iconfont icon-reads" />
                          <span>{handleNumber(item.watchCount || 0)}</span>
                        </div>
                        <div className={classNames(styles.zt_card_icon)}>
                          <i className="iconfont icon-zan" />
                          <span>{handleNumber(item.zanCount || 0)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {ztlist.length >= pagenation.count && pagenation.count > 8 && (
                <div className={styles.loader}>----------到底啦----------</div>
              )}
            </InfiniteScroll>
          )}
        {ztlist && ztlist.length === 0 && (
          <>
            <img
              src={nodata}
              alt=""
              className={styles.nodata}
              style={{ marginTop: `${130 - Math.floor(tagList && tagList.length / 10) * 10}px` }}
            />
            <div className={styles.nodata_text}>小编正在疯狂码字，专题内容持续扩充ing…</div>
          </>
        )}
      </div>
      <ScrollTop />
    </div>
  );
});
